import Tabs, { TabPane } from 'rc-tabs';
import './tabs.scss';
import classNames from 'classnames';
// import { Size } from '../types/size';
import React, { ReactNode } from 'react';

export interface ZenTabProps {
    defaultActiveKey?: string;
    activeKey?: string;
    onChange?: (key: any) => void;
    size?: 'sm' | 'xs';
    className?: string;
    children: ReactNode;
    prefixCls?: string;
}

function ZenTabs({
    defaultActiveKey = '1',
    onChange,
    size = 'sm',
    className,
    prefixCls = 'zen',
    activeKey,
    children,
}: ZenTabProps) {
    const classList = () => {
        return classNames([
            {
                [`zen-tabs-${size}`]: size,
            },
            className,
        ]);
    };
    return (
        <Tabs
            activeKey={activeKey}
            defaultActiveKey={defaultActiveKey}
            moreTransitionName="slide-up"
            prefixCls={prefixCls}
            className={classList()}
            onChange={onChange}
        >
            {children}
        </Tabs>
    );
}

export { TabPane as ZenTabPane };
export default ZenTabs;
